__turbopack_context__.v({
  "enable-second-mode-button": "input-module-scss-module__Scc2cq__enable-second-mode-button",
  "error": "input-module-scss-module__Scc2cq__error",
  "full-width": "input-module-scss-module__Scc2cq__full-width",
  "helper-text": "input-module-scss-module__Scc2cq__helper-text",
  "input": "input-module-scss-module__Scc2cq__input",
  "inputs-container": "input-module-scss-module__Scc2cq__inputs-container",
  "middle": "input-module-scss-module__Scc2cq__middle",
  "middle-line": "input-module-scss-module__Scc2cq__middle-line",
  "middle__default": "input-module-scss-module__Scc2cq__middle__default",
  "middle__dense": "input-module-scss-module__Scc2cq__middle__dense",
  "text-field-container": "input-module-scss-module__Scc2cq__text-field-container",
});
